import { render } from "./folderList-tab.vue?vue&type=template&id=04782a97"
import script from "./folderList-tab.vue?vue&type=script&lang=js"
export * from "./folderList-tab.vue?vue&type=script&lang=js"

import "./folderList-tab.vue?vue&type=style&index=0&id=04782a97&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__